import React from "react";
import loadable from "@loadable/component";
import { useAppState } from "@state";
import { Container, ButtonAlt } from "@atoms";
import { HeadingWIcon, VideoAudioTease } from "@molecules";

const SearchModal = loadable(() => import("@organisms/SearchModal"));

const VideoAudioGrid = ({ data: videoAudio, headingStyles, className }) => {
  const [, dispatch] = useAppState();

  const openSearch = () =>
    dispatch({
      type: "openModal",
      // eslint-disable-next-line react/no-unstable-nested-components
      content: React.memo(() => (
        <SearchModal
          content={videoAudio.documents.map((a, i) => {
            return { ...a, id: i };
          })}
          placeholder="Search Video and Audio"
          resultCard={VideoAudioTease}
          param="qv"
          backCopy="Go to All Resources"
        />
      )),
    });

  return (
    <div className={className}>
      <Container>
        <div className="flex flex-wrap justify-between">
          <div className="w-full md:w-2/3">
            <HeadingWIcon {...videoAudio} colors={headingStyles} small />
          </div>
          <div className="mt-4 w-auto flex-shrink-0 pt-4 md:mt-0">
            <ButtonAlt icon="search" reverse color="gold" onClick={openSearch}>
              Search {videoAudio.heading}
            </ButtonAlt>
          </div>
        </div>
        <ul className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2 md:mt-12 md:gap-12 lg:grid-cols-3">
          {videoAudio.documents.slice(0, 6).map(d => (
            <li key={d.uid} className="w-full">
              <VideoAudioTease condensed {...d} />
            </li>
          ))}
        </ul>
        <div className="mt-12">
          <ButtonAlt onClick={openSearch} color="gold">
            More {videoAudio.heading}
          </ButtonAlt>
        </div>
      </Container>
    </div>
  );
};

export default VideoAudioGrid;
